import React, { createContext, useContext, useState } from 'react';

const AssetManagerContext = createContext();

// export const columnDefs = {
//     'Project Strategy': 'multi enum',
//     'Business Line': 'enum',
//     'Property Type': 'enum',
//     'Occupancy Status': 'enum',
//     'Transaction Status': 'enum',
//     'Rental Status': 'enum',
// };

export const enumOptions = {
    'Project Strategy': [
        'Wholesale',
        'Remodel with permit',
        'Remodel without permit',
        'Removdel to rent(with permit)',
        'Remodel to rent(without permit)',
        'ADU',
        'Addition',
        'New Construction',
        'SB9 lot split',
        'SB9 Duplex',
        'Community Development',
        'Duplex to condos',
        'Sell',
        'Clean up and sell',
        'Sell to client before close',
        'Double Close',
        'Put on market',
        'Sell as is',
        'long-term rental',
        'Mid-Term Rental',
        'Airbnb',
        'Rent as is',
        'Add Units',
        'Office',
        'Sell with approved plan set',
        'Clear Code Violation',
        'Legalize',
        'Tiny house',
        'Prefab House',
        'Eviction',
        'Builders Remedy',
    ],
    'Business Line': [
        'Wholesale',
        'Alera Homes',
        'Al Homes',
        'Astro Pie Properties',
        'AlphaNRI',
        'OFFICE',
        'Other',
    ],
    'Property Type': [
        'SFH',
        'Duplex',
        'Triplex',
        'Fourplex',
        'Commercial',
        'SFH+ADU',
        'Townhouse',
        'Condo',
        'Apartment',
        'Vacant Land',
    ],
    'Occupancy Status': [
        'Owner Rent Back',
        'Ready to rent',
        'Vacant lot',
        'Vacant Property',
        'Under Construction',
        'Needs Eviction',
        'Rental',
        "Stephanie's Primary",
        'Office',
        "De's Primary",
        'Warehouse',
        'Sold',
    ],
    'Transaction Status': [
        'Acq offering',
        'Acq contingent',
        'Acq pending',
        'Acq closed',
        'Acq Canceled',
        'Internal in contract',
        'Contract Assigned',
        'Double Closed',
        'Acq Lost',
        'Coming soon with tenants-30 days',
        'Prepare to sell with tenants',
        'Presale-Listing on mls',
        'listing in 30 days?',
        'Prepare for sale',
        'MLS Coming Soon',
        'Listing on the market',
        'Listing Contingent',
        'Listing Pending',
        'Listing Withdraw',
        'Coming soon-30 days',
        'Coming soon never on mls',
        'Sold',
        'Searching buyer off market',
        'Client',
    ],
    'Rental Status': [
        '',
        'tenant moved in',
        'listing',
        'prepare for listing',
        'airbnb',
        'lease signed',
    ],
    'Loan Status': [
        '',
        'Purchase pending',
        'Refi quoting',
        'Refi pending',
        'Active',
        'Closed',
    ],
    'Loan Type': [
        'Purchase',
        'Bridge',
        'New Construction Loan',
        '2 Phase loan',
        'Private lender',
        'ADU',
        'Rehab',
        'All Cash',
        'Extension',
        'Bank Statement',
        'DSCR',
        'Conventional loan',
        'Combined Loan',
        'Commercial',
    ],
    'Pipeline Category': [
        'SB9 Split',
        'SFH',
        'Addition',
        'Remodel',
        'ADU',
        'SB9 No Split',
        'Community Development',
        'Condo Conversion',
        'OTHER',
    ],
    Investor: [
        'Resinova',
        'JimmyBR',
        'Sinnabrrrr',
        'YY',
        'De & Heather',
        'Highstar',
        'xiaobrrr',
        'Ming Luo',
        'Roger',
        'GQ',
        '中福',
        'YTM',
        'Sunnie',
        'Mau',
        'Jing Yang',
        'Pi',
        'ze li',
        'lihan lian',
        'sunny land investment',
        '光哥宋总 longridge',
        'zhenzhen + Alec wang',
        'Nancy',
        '晨曦',
    ],
};

export const columnDefs = {
    City: 'string',
    County: 'string',
    State: 'string',
    Zip: 'string',
    Price: 'number',
    'Title Holder': 'string',
    'Project Strategy': 'multi enum',
    'Business Line': 'enum',
    'Property Type': 'enum',
    'Occupancy Status': 'enum',
    HOA: 'boolean',
    'Solar Panel': 'boolean',
    // 'Insurance Policy': true,
    'Annual Property Tax': 'number',
    'Annual Insurance Premium': 'number',
    'As Is Market Value': 'number',
    Equity: 'number',
    'Monthly PITI': 'number',
    LTV: 'number',
    // 'PL Link': true,
    // 'Grand Deed': true,
    'Purchase Price': 'number',
    'Under Constract Date': 'date',
    'Transaction Status': 'enum',
    'Purchase Close Date': 'date',
    'Title Binder Info': 'string',
    'Title History': 'string',
    '1031 Company Info': 'string',
    'Target Exit Date': 'date',
    'Relisting Agent': 'string',
    'Sold Price': 'number',
    'Sold Date': 'date',
    'New Address': 'string',
    'Exit Pipeline': 'string',
    'Pipeline Category': 'multi enum',
    Investor: 'multi enum',
    // 'Outstanding Loan Amount Sum': 'number',

    // loan
    'Loan Status': 'enum',
    'Outstanding Loan Amount': 'number',
    'Monthly Mortgage Payment': 'number',
    'Loan Prepay Restriction': 'string',
    'Loan Service Company': 'string',
    'Loan Type': 'multi enum',
    'Rehab Loan Budget': 'number',
    'Released Rehab Loan': 'number',
    Lien: 'number',
    Impound: 'bool',

    'Loan Amount (1st)': 'number',
    'Lender (1st)': 'string',
    'Rate (1st)': 'number',
    'Maturity Date (1st)': 'date',

    'Loan Amount (2nd)': 'number',
    'Lender (2nd)': 'string',
    'Rate (2nd)': 'number',
    'Maturity Date (2nd)': 'date',

    'Loan Amount (3rd)': 'number',
    'Lender (3rd)': 'string',
    'Rate (3rd)': 'number',
    'Maturity Date (3rd)': 'date',

    'Loan Amount (4th)': 'number',
    'Lender (4th)': 'string',
    'Rate (4th)': 'number',
    'Maturity Date (4th)': 'date',

    'Rental Status': 'enum',
    'Monthly Rent': 'number',
    'Lease Start Date': 'date',
    'Lease Expire Date': 'date',

    // Design Info
    'Approved Plan Package': 'array',
    'Target Permit Date': 'date',

    // Investment
    'AlphaX Ownership': 'number',

    // Other
    'SB9 Affidavit Signatory': 'string',

    // Accounting
    'Cash Invested': 'number',
    'Cost of Capital': 'number',
    'Total Cost Exclude Capital': 'number',
    'Estimate Profit': 'number',
    'AlphaX Profit': 'number',
    'PL Link': 'string',
};

export const title2Field = {
    Address: 'address',
    City: 'city',
    County: 'county',
    State: 'state',
    Zip: 'zip',
    'Title Holder': 'titleholder',
    'Project Strategy': 'project_strategy',
    'Business Line': 'business_line',
    'Property Type': 'property_type',
    'Occupancy Status': 'occupancy_status',
    HOA: 'hoa_status',
    'Solar Panel': 'solar_panel',
    'Insurance Policy': 'insurance_policy',
    'Annual Property Tax': 'annual_property_tax',
    'Annual Insurance Premium': 'annual_insurance_premium',
    'As Is Market Value': 'as_is_value',
    Equity: 'equity',
    'Monthly PITI': 'monthly_piti',
    LTV: 'ltv',
    'PL Link': 'pl_link',
    'Grand Deed': 'grand_deed_prelim',
    // Transaction Info
    'Purchase Price': 'purchase_price',
    'Under Constract Date': 'under_contract_date',
    'Transaction Status': 'transaction_status',
    'Purchase Close Date': 'purchase_close_date',
    'Title Binder Info': 'title_binder_info',
    'Title History': 'title_history',
    '1031 Company Info': '1031_company_info',
    'Target Exit Date': 'target_exit_date',
    'Relisting Agent': 'relisting_agent',
    'Sold Price': 'sold_price',
    'Sold Date': 'sold_date',
    'New Address': 'new_address',
    'Exit Pipeline': 'exit_pipeline',
    'Pipeline Category': 'pipeline_category',
    Investor: 'investor',
    // Loan Info
    // 'Outstanding Loan Amount Sum': 'outstanding_loan_amount_sum',

    'Loan Status': 'loan_status',
    'Outstanding Loan Amount': 'outstanding_loan_amount',
    'Monthly Mortgage Payment': 'monthly_mortgage_payment',
    'Loan Prepay Restriction': 'loan_prepay_restriction',
    'Loan Service Company': 'loan_service_company',
    'Loan Type': 'loan_type',
    'Rehab Loan Budget': 'rehab_loan_budget',
    'Released Rehab Loan': 'released_rehab_loan',
    Lien: 'lien',
    Impound: 'impound',

    'Loan Amount (1st)': 'loan_amount',
    'Lender (1st)': 'lender',
    'Rate (1st)': 'rate',
    'Maturity Date (1st)': 'maturity_date',

    'Loan Amount (2nd)': 'loan_amount_2',
    'Lender (2nd)': 'lender_2',
    'Rate (2nd)': 'rate_2',
    'Maturity Date (2nd)': 'maturity_date_2',

    'Loan Amount (3rd)': 'loan_amount_3',
    'Lender (3rd)': 'lender_3',
    'Rate (3rd)': 'rate_3',
    'Maturity Date (3rd)': 'maturity_date_3',

    'Loan Amount (4th)': 'loan_amount_4',
    'Lender (4th)': 'lender_4',
    'Rate (4th)': 'rate_4',
    'Maturity Date (4th)': 'maturity_date_4',

    // Rental Info
    'Rental Status': 'rental_status',
    'Monthly Rent': 'monthly_rent',
    'Lease Start Date': 'lease_start_date',
    'Lease Expire Date': 'lease_expire_date',

    // Design Info
    'Approved Plan Package': 'approved_plan_package',
    'Target Permit Date': 'target_permit_date',

    // Investment
    'AlphaX Ownership': 'alphax_ownership',

    // Other
    'SB9 Affidavit Signatory': 'sb9_affidavit_signatory',

    // Accounting
    'Cash Invested': 'cash_invested',
    'Cost of Capital': 'cost_of_capital',
    'Total Cost Exclude Capital': 'total_cost_exclude_capital',
    'Estimate Profit': 'estimate_profit',
    'AlphaX Profit': 'alphax_profit',
    'PL Link': 'pl_link',
};

export const initialCols = {
    'Title Holder': true,
    'Project Strategy': true,
    'Business Line': true,
    'Property Type': true,
    'Occupancy Status': true,
    HOA: true,
    'Solar Panel': true,
    'Insurance Policy': true,
    'Annual Property Tax': true,
    'Annual Insurance Premium': true,
    'As Is Market Value': true,
    Equity: true,
    'Monthly PITI': true,
    LTV: true,
    'PL Link': true,
    'Grand Deed': true,
    'Purchase Price': true,
    'Under Constract Date': true,
    'Transaction Status': true,
    'Purchase Close Date': true,
    'Title Binder Info': true,
    'Title History': true,
    '1031 Company Info': true,
    'Target Exit Date': true,
    'Relisting Agent': true,
    'Sold Price': true,
    'Sold Date': true,
    'New Address': true,
    'Exit Pipeline': true,
    'Pipeline Category': true,
    Investor: true,
    // 'Outstanding Loan Amount Sum': true,
    'Loan Status': true,
    'Outstanding Loan Amount': true,
    'Monthly Mortgage Payment': true,
    'Loan Prepay Restriction': true,
    'Loan Service Company': true,
    'Loan Type': true,
    'Rehab Loan Budget': true,
    'Released Rehab Loan': true,
    Lien: true,
    Impound: true,

    'Loan Amount (1st)': true,
    'Lender (1st)': true,
    'Rate (1st)': true,
    'Maturity Date (1st)': true,

    'Loan Amount (2nd)': true,
    'Lender (2nd)': true,
    'Rate (2nd)': true,
    'Maturity Date (2nd)': true,

    'Loan Amount (3rd)': true,
    'Lender (3rd)': true,
    'Rate (3rd)': true,
    'Maturity Date (3rd)': true,

    'Loan Amount (4th)': true,
    'Lender (4th)': true,
    'Rate (4th)': true,
    'Maturity Date (4th)': true,

    'Rental Status': true,
    'Monthly Rent': true,
    'Lease Start Date': true,
    'Lease Expire Date': true,

    // Design Info
    'Approved Plan Package': true,
    'Target Permit Date': true,

    // Investment
    'AlphaX Ownership': true,

    // Other
    'SB9 Affidavit Signatory': true,

    // Accounting
    'Cash Invested': true,
    'Cost of Capital': true,
    'Total Cost Exclude Capital': true,
    'Estimate Profit': true,
    'AlphaX Profit': true,
    'PL Link': true,
};

export const FilterProvider = ({ children }) => {
    const [filteredText, setFilteredText] = useState('');
    const [visibleCols, setVisibleCols] = useState(initialCols);
    const [tempCols, setTempCols] = useState(initialCols);
    const [assetFilters, setAssetFilters] = useState([]);
    const [filterLogic, setFilterLogic] = useState('all');
    const [groupBy, setGroupBy] = useState([]);

    return (
        <AssetManagerContext.Provider
            value={{
                filteredText,
                setFilteredText,
                visibleCols,
                setVisibleCols,
                tempCols,
                setTempCols,
                assetFilters,
                setAssetFilters,
                filterLogic,
                setFilterLogic,
                groupBy,
                setGroupBy,
            }}
        >
            {children}
        </AssetManagerContext.Provider>
    );
};

export const useFilter = () => {
    const context = useContext(AssetManagerContext);
    if (!context) {
        throw new Error('useFilter must be used within a FilterProvider');
    }
    return context;
};
